import Logger from '../lib/logger';

export default class ProfessionalSimpleDspSetup {
	constructor(dom) {
		this.NAME = 'ProfessionalSimpleDspSetup';
		this.dom = dom;
		this.openBtns = dom.querySelectorAll(
			'[data-professional-simple-dsp-setup-open]'
		);
		this.modal = dom.querySelector('[data-professional-simple-dsp-setup-modal]');
		this.backdrop = dom.querySelector(
			'[data-professional-simple-dsp-setup-backdrop]'
		);
		this.closeBtn = dom.querySelector(
			'[data-professional-simple-dsp-setup-close]'
		);
		this.iframe = dom.querySelector(
			'[data-professional-simple-dsp-setup-iframe]'
		);
		this.onEscBound = this.onEsc.bind(this);
		this.lastTrigger = null;
		this.scrollY = 0;
	}

	init() {
		Logger.info(`${this.NAME} > init`);

		if (!this.modal || !this.iframe) return;

		this.openBtns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				this.openFrom(btn);
			});
		});

		this.closeBtn?.addEventListener('click', (e) => {
			e.preventDefault();
			this.close(true);
		});

		this.backdrop?.addEventListener('click', () => {
			this.close(true);
		});
	}

	openFrom(trigger) {
		const url = trigger.getAttribute('data-iframe-url');
		if (!url) return;

		const title =
			trigger.getAttribute('data-iframe-title') || 'Blaze dashboard';

		this.lastTrigger = trigger;
		this.iframe.setAttribute('title', title);
		this.iframe.src = url;

		this.scrollY = window.scrollY;
		document.body.style.top = `-${this.scrollY}px`;
		document.body.style.paddingRight = '15px';
		document.body.style.position = 'fixed';
		document.body.style.width = '100%';
		document.body.style.zIndex = '0';

		this.modal.removeAttribute('hidden');
		this.modal.setAttribute('aria-hidden', 'false');

		document.addEventListener('keydown', this.onEscBound);
		this.closeBtn?.focus();
	}

	close(instant) {
		this.modal.setAttribute('hidden', '');
		this.modal.setAttribute('aria-hidden', 'true');
		this.iframe.src = '';

		document.body.style.paddingRight = '';
		document.body.style.position = '';
		document.body.style.width = '';
		document.body.style.top = '';
		document.body.style.zIndex = '';

		const y = this.scrollY;
		document.removeEventListener('keydown', this.onEscBound);

		if (instant && typeof window.scrollTo === 'function') {
			window.scrollTo({ top: y, behavior: 'instant' });
		} else {
			window.scrollTo(0, y);
		}

		if (this.lastTrigger) {
			this.lastTrigger.focus();
			this.lastTrigger = null;
		}
	}

	onEsc(e) {
		if (e.key === 'Escape') {
			this.close(true);
		}
	}
}
